import { render, staticRenderFns } from "./HomeOnboarding.vue?vue&type=template&id=339099b2"
import script from "./HomeOnboarding.vue?vue&type=script&lang=js"
export * from "./HomeOnboarding.vue?vue&type=script&lang=js"
import style0 from "./HomeOnboarding.vue?vue&type=style&index=0&id=339099b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports